import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets the scroll position on every navigation. Without this the browser keeps
// the previous scroll offset, so following a footer link lands you at the bottom
// of the new page instead of the top.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export { ScrollToTop };
